(function ($) {
    $.fn.testimonialCarousel = function () {

        this.each((index, element) => {

            const $self = $(element);
            const $slider = $self.find('.content-splide');
            const $sliderSlides = $slider.find('.splide__slide');

            const $imageSlider = $self.find('.image-splide');

            //let containerWidth = $slider.width();

            const sliderOptions = {
                perPage: 1,
                direction: 'ltr',
                //autoplay: true,
                pauseOnHover: true,
                pauseOnFocus: false,
                arrows: true,
                pagination: false,
                autoHeight: true,
            };

            const imageSliderOptions = {
                type: 'fade',
                perPage: 1,
                direction: 'ltr',
                autoplay: false,
                pauseOnHover: true,
                pauseOnFocus: false,
                arrows: false,
                pagination: false,
                drag: false,
            };

            let slider, imageSlider;

            $self.currentBreakpoint = window.currentBreakpoint();

            function getSliderOptions() {
                return { ...sliderOptions };
            }

            function getImageSliderOptions() {
                return { ...imageSliderOptions };
            }

            function initSlider() {
                //$slider.css('width', (containerWidth + 150) + 'px');
                slider = new window.Splide($slider[0], getSliderOptions()).mount();
                imageSlider = new window.Splide($imageSlider[0], getImageSliderOptions()).mount();

                slider.on('move', function (newIndex, oldIndex, destIndex) {
                    console.log(newIndex + oldIndex + destIndex);
                    imageSlider.go(newIndex);
                    if(checkNoDot(newIndex)){
                        $slider.addClass('full-width');
                    }else{
                        $slider.removeClass('full-width');
                    }
                    setSlideHeight(newIndex);
                });

                slider.on('move', function (newIndex) {
                    setSlideHeight(newIndex);
                });
                
                setSlideHeight(0);
            }

            $(window).on('resize', () => {
                update();
                slider.destroy();
                imageSlider.destroy();
                initSlider();
            });

            function update() {
                /** Update currentBreakpoint */
                $self.currentBreakpoint = window.currentBreakpoint();
                $slider.addClass('updated');
            }

            function checkNoDot(index){
                return $slider.find('.slide:nth-child('+(index + 1)+')').hasClass('dot-type-none');
            }

            function setSlideHeight(slideIndex){
                const $slide = $sliderSlides.eq(slideIndex);
                const $slideContent = $slide.find('.testimonial_container');
                $sliderSlides.css('maxHeight', 0);
                $slide.css('maxHeight', $slideContent.outerHeight());
            }

            initSlider();
            
        });


        return this;
    }

    $(() => {
        $('.module.testimonial_carousel').testimonialCarousel();
    })

})($);




// WEBPACK FOOTER //
// ./scripts/modules/blocks/testimonial-carousel.js